import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Role } from "../../shared/models/role";

@Component({
  selector: 'app-role-selector',
  templateUrl: './role-selector.component.html',
  styleUrls: ['./role-selector.component.css']
})
export class RoleSelectorComponent implements OnInit, OnChanges {
  
  @Output() selected = new EventEmitter<Role>();
  @Input() role:Role;
  @Input() disabled:boolean;
  private currentRole:Role;

  constructor() { 
  }

  ngOnInit() {
    this.currentRole = this.role;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.currentRole = this.role;
  }


  // TODO: stephen eventually this needs to be a checklist of roles.
  public setAdmin() {
    if (this.currentRole === Role.Admin) {
      this.currentRole = Role.Registered;
    }
    else {
      this.currentRole = Role.Admin;
    }
    this.selected.emit(this.currentRole);
  }

  public isAdmin() {
    return this.currentRole <= Role.Admin;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/role-selector/role-selector.component.ts